import React, { useRef, useState } from "react";
import {
    VirtualScrollingTreeBrowserComponent,
    useTreeBrowserInitialise,
    createInitialState,
    FlatLibraryNode,
    FolderBrowserView,
    TreeBrowserDomainNodeContext,
} from "@iventis/tree-browser";
import { dataTestIds } from "@iventis/testing";
import { LibraryNodeExtraProps, libraryNodeComponents } from "./library-nodes";
import { LibraryGalleryView } from "./library-tile-view";
import { createRootNode, createMockNodeServices, getInteractivityMock } from "./library-testing-helpers";

const numberOfNodes = 250;
const numberOfChildrenPerNode = 100;

export const LibraryTestingComponent = () => {
    const rootNode = useRef<FlatLibraryNode>(createRootNode(numberOfNodes));
    const [viewType, setViewType] = useState(FolderBrowserView.List);

    const [state, context] = useTreeBrowserInitialise(
        createInitialState<FlatLibraryNode>({ tree: rootNode.current, mainNodeId: rootNode.current.id }),
        createMockNodeServices(rootNode.current, numberOfChildrenPerNode),
        null
    );

    return (
        <div style={{ height: "100vh", width: "100vw", display: "flex", flexDirection: "column" }} data-testid={dataTestIds.libraryTesting.container}>
            <div style={{ height: "80%", width: "100%" }}>
                <TreeBrowserDomainNodeContext.Provider value={context}>
                    {viewType === FolderBrowserView.List && (
                        <VirtualScrollingTreeBrowserComponent<FlatLibraryNode, LibraryNodeExtraProps>
                            node={state.tree}
                            openNodes={state.expandedNodeIds}
                            components={libraryNodeComponents}
                            getInteractivity={getInteractivityMock}
                            extraProps={{ viewType: FolderBrowserView.List, isDragging: false }}
                        />
                    )}
                    {viewType === FolderBrowserView.Tile && (
                        <LibraryGalleryView
                            tree={state.tree}
                            components={libraryNodeComponents}
                            getInteractivity={getInteractivityMock}
                            extraProps={{
                                viewType: FolderBrowserView.Tile,
                                isDragging: false,
                            }}
                        />
                    )}
                </TreeBrowserDomainNodeContext.Provider>
            </div>
            <div style={{ height: "20%", width: "100%" }}>
                View Type
                <select value={viewType} onChange={(event) => setViewType(event.target.value as FolderBrowserView)} data-testid={dataTestIds.libraryTesting.viewTypeSelector}>
                    <option key={FolderBrowserView.List.toString()} value={FolderBrowserView.List} data-testid={dataTestIds.libraryTesting.viewTypeList}>
                        {FolderBrowserView.List.toString()}
                    </option>
                    <option key={FolderBrowserView.Tile.toString()} value={FolderBrowserView.Tile} data-testid={dataTestIds.libraryTesting.viewTypeTile}>
                        {FolderBrowserView.Tile.toString()}
                    </option>
                </select>
            </div>
        </div>
    );
};

export default LibraryTestingComponent;
